/* istanbul ignore file */
// @ts-check
import { CallToActionCard } from '@linearb/linui-common';
import { callToActionSlides } from './slides';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';

const CallToActionSlides = () => {
  const { isFreePlan } = useDoraFeatureFlags();
  const slides = callToActionSlides({ showCta: isFreePlan });

  return <CallToActionCard sx={{ height: '22rem' }} slides={slides} />;
};

export default CallToActionSlides;
